import React, { useMemo } from 'react'

import { BASE_URL, ICONS } from '../../../../constants'
import ListHeader from '../../../components/ListHeader'
import ListTable from '../../../components/ListTable'

import { ROUTE_NAME, API_URL } from '../constants'

import { useItems } from '../../../hooks'

const columns = [
  { header: 'Id', value: (item) => item.id },
  {
    header: 'Type',
    value: (item) => (
      <img
        alt={item.name}
        src={`${BASE_URL}${ICONS.AI.BORDERLESS.DIR}${item.type.icon}`}
      />
    ),
  },
  { header: 'Name', value: (item) => item.name, isLink: true },
  {
    header: 'Status',
    value: (item) => (item.status === 0 ? 'ACTIVE' : 'CLOSED'),
  },
  {
    header: 'Created',
    value: (item) => `by ${item.loginLog.user.username} @ ${item.createdDate}`,
  },
]

const SigEventsIncidentsList = () => {
  const [{ response: items, isLoading, error }] = useItems(API_URL)
  const openIncidents = useMemo(
    () => items && items.filter(({ status }) => status === 0),
    [items]
  )
  const closedIncidents = useMemo(
    () => items && items.filter(({ status }) => status === 1),
    [items]
  )

  if (isLoading) return <div>Loading..</div>
  if (error) return <div>{error}</div>

  return (
    <>
      <ListHeader title="SigEvents Incidents" routeName={ROUTE_NAME} />
      <ListTable
        title="Active"
        items={openIncidents}
        columns={columns}
        routeName={ROUTE_NAME}
      />
      <ListTable
        title="Closed"
        items={closedIncidents}
        columns={columns}
        routeName={ROUTE_NAME}
      />
    </>
  )
}

export default SigEventsIncidentsList
